export default function(x) {
  return typeof x === "object" && "length" in x
    ? x // Array, TypedArray, NodeList, array-like
    : Array.from(x); // Map, Set, iterable, string, or anything else
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-selection/src/array.js
// module id = 3
// module chunks = 0